import { userAgentMatch } from './user-agent-match';

export function isAndroid(): boolean {
  return userAgentMatch(/Android/i) && !userAgentMatch(/Windows Phone/i);
}
